import React, { createContext, useContext, useEffect, useState } from 'react';
import { loadStripe, Stripe } from '@stripe/stripe-js';

interface StripeContextType {
  stripe: Stripe | null;
}

const StripeContext = createContext<StripeContextType>({ stripe: null });

export const useStripe = () => useContext(StripeContext);

interface StripeProviderProps {
  children: React.ReactNode;
}

export const StripeProvider: React.FC<StripeProviderProps> = ({ children }) => {
  const [stripe, setStripe] = useState<Stripe | null>(null);

  useEffect(() => {
    const initStripe = async () => {
      // Get publishable key from environment or API
      const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
      
      if (publishableKey) {
        const stripeInstance = await loadStripe(publishableKey);
        setStripe(stripeInstance);
      } else {
        console.warn('Stripe publishable key not found');
      }
    };

    initStripe();
  }, []);

  return (
    <StripeContext.Provider value={{ stripe }}>
      {children}
    </StripeContext.Provider>
  );
};